import { createFileRoute } from "@tanstack/react-router";
import TeenDepression from "@/pages/articles/TeenDepression";
export const Route = createFileRoute(
  "/teen-depression-hard-year-or-real-illness",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Teen Depression Hard Year Or Real Illness | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Is your teen going through a hard year or a real illness? Learn the signs of teen depression and when to seek help in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Teen Depression Hard Year Or Real Illness | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Is your teen going through a hard year or a real illness? Learn the signs of teen depression and when to seek help in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/teen-depression-hard-year-or-real-illness",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/teen-depression-hard-year-or-real-illness",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TeenDepression />;
}
